
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import i18n from '@/i18n';
import { GQL_InvoiceDeliveryMethodEnum } from '@/queries/global';
import { StopActivatingPopup } from '@/decorators/stopPopupActive';
import { watchInvoice } from '@/app/invoiceWatch';
import gql from 'graphql-tag';

const CREATE_INVOICE_MAIL_LOG = gql`
  mutation createInvoiceMailLog(
    $invoiceId: ID!,
    $destination: String!,
    $deliveryMethod: InvoiceDeliveryMethodEnum!,
    $sentAt: DateTime!,
  ) {
    createInvoiceMailLog(input: {
      invoiceId: $invoiceId
      destination: $destination
      deliveryMethod: $deliveryMethod
      sentAt: $sentAt
    }) {
      logInvoiceMail {
        id destination sentAt
        deliveryMethod
        sentBy { id name }
        deliveryStatus
        deliveryError
        attachmentsCount
      }
    }
  },
`;

@Component
export default class InvoiceDeliveryButton extends Vue {
  @Prop() invoice!: GQL_newInvoiceData_newInvoice;
  @Prop({ type: String, default: '' }) initialDestination!: string;
  @Prop() deliveryMethod!: GQL_InvoiceDeliveryMethodEnum;
  @Prop({ type: String, default: 'standard' }) color!: string;

  public destination: string = this.initialDestination;
  public sentAt: string = this.$dayjs().utc().format('YYYY-MM-DDTHH:mm:ssZ');
  private showDeliveryDialog = false;
  private validForm = true;

  public rules: IRules = {
    destination: [
      {
        validation: validateRequired(),
        message: i18n.t('Error.required', { field: i18n.t('Invoice.DeliveryLogs.sentTo') }),
      },
    ],
    sentAt: [
      {
        validation: validateRequired(),
        message: i18n.t('Error.required', { field: i18n.t('Invoice.DeliveryLogs.sentDate') }),
      },
    ],
  }

  private get sendingIcon() {
    return this.deliveryMethod === 'ehf' ? 'paper-plane' : 'envelope';
  }

  private get deliveryMethodLocalized() {
    return this.$t(`Invoice.DeliveryLogs.DeliveryMethod.${this.deliveryMethod}`);
  }

  @StopActivatingPopup()
  // prevents the click from bubbling to a parent popup and stealing focus,
  // which would leave this dialog opening behind it
  private openDeliveryDialog() {
    this.showDeliveryDialog = true;
  }

  private createDeliveryLog() {
    this.$sMessage.info(i18n.t('Invoice.DeliveryLogs.creatingLog'));
    watchInvoice(this.invoice.id);

    this.$apollo.mutate({
      mutation: CREATE_INVOICE_MAIL_LOG,
      variables: {
        invoiceId: this.invoice.id,
        destination: this.destination,
        deliveryMethod: this.deliveryMethod,
        sentAt: this.sentAt,
      },
    }).then(data => {
      this.$sMessage.success(i18n.t('Invoice.DeliveryLogs.createLogSuccess'));
      this.$set(this.invoice, 'emailLogs', this.invoice.emailLogs.concat(data.data.createInvoiceMailLog.logInvoiceMail));

      this.sentAt = this.$dayjs().utc().format('YYYY-MM-DDTHH:mm:ssZ');

      this.showDeliveryDialog = false;
      this.$emit('sent');
    });
  }
}
